<template>
  <div>
    <toast :is-show="loading" icon="loading" text="加载中"></toast>
    <toast
      :is-show.sync="hasError"
      icon="none"
      :text="errorTips"
      :auto-hide="true"
    ></toast>
    <div v-if="!loading">
      <section class="page-panel-coupons">
        <panel v-if="couponsInfo.length" class="mwe-panel--coupons">
          <!-- 标题 -->
          <template slot="title">
            <span>我的优惠券</span>
          </template>
          <div class="mwe-panel-expand-content">
            <!-- 优惠券 S  -->
            <div
              class="act-list act-list--row list-coupons-voucher coupons-wrap"
            >
              <div class="act-list-inner">
                <div
                  v-for="(item, index) in couponsInfo"
                  :key="index"
                  class="act-list-item cur"
                >
                  <div class="voucher voucher--h">
                    <div class="voucher-inner">
                      <div class="voucher-hd">
                        <div class="voucher-price">
                          <span class="voucher-price-unit">¥</span>
                          <span class="voucher-price-val">{{
                            COUPON_PRIZE_ID_MAP[item.prizeId] &&
                            COUPON_PRIZE_ID_MAP[item.prizeId].value
                          }}</span>
                        </div>
                      </div>
                      <div class="voucher-bd">
                        <h3 class="voucher-name">优惠券</h3>
                        <p class="voucher-extra-tip">
                          {{
                            COUPON_PRIZE_ID_MAP[item.prizeId] &&
                            COUPON_PRIZE_ID_MAP[item.prizeId].useScope
                          }}
                        </p>
                        <p class="voucher-extra-time">
                          有效期12.10-12.12
                        </p>
                      </div>
                      <div
                        v-if="item.status.id === 1 || item.status.id === 2"
                        class="voucher-ft"
                      >
                        <div class="voucher-used">
                          {{ item.status.id === 1 ? '已使用' : '已过期' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 优惠券 E  -->
          </div>
        </panel>
        <panel v-if="qbCardsInfo.length" class="mwe-panel--coupons">
          <!-- 标题 -->
          <template slot="title">
            <span>我的Q币卡</span>
          </template>
          <div class="mwe-panel-expand-content">
            <!-- 优惠券 S  -->
            <div
              class="act-list act-list--row list-coupons-voucher coupons-wrap"
            >
              <div class="act-list-inner">
                <div
                  v-for="(item, index) in qbCardsInfo"
                  :key="index + 'a'"
                  class="act-list-item cur"
                >
                  <div class="voucher voucher--h">
                    <div class="voucher-inner">
                      <div class="voucher-hd">
                        <div class="voucher-price">
                          <span class="voucher-price-val">{{
                            LOTTERY_PRIZE_ID_MAP[item.prizeId] &&
                            LOTTERY_PRIZE_ID_MAP[item.prizeId].value
                          }}</span>
                          <span class="voucher-price-unit">Q币</span>
                        </div>
                      </div>
                      <div class="voucher-bd">
                        <p class="voucher-extra-tip">
                          卡号：{{ item.qbCardId }}
                        </p>
                        <p class="voucher-extra-tip">
                          密码：{{ item.qbCardPassword }}
                        </p>
                        <p class="voucher-extra-time">
                          有效期：12.10-12.30
                        </p>
                      </div>
                      <div class="voucher-ft">
                        <div
                          class="voucher-extra-tip"
                          @click="handleCopy(item.qbCardId)"
                        >
                          复制卡号
                        </div>
                        <div
                          class="voucher-extra-tip"
                          @click="handleCopy(item.qbCardPassword)"
                        >
                          复制密码
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 优惠券 E  -->
          </div>
        </panel>
        <!-- 无优惠券 S -->
        <div
          v-if="!couponsInfo.length && !qbCardsInfo.length"
          class="notification"
        >
          <div class="notification-inner">
            <h6 class="notification-tit">还没有获得任何奖品哦</h6>
          </div>
        </div>
        <!-- 无优惠券 E -->
      </section>
    </div>
  </div>
</template>

<script>
import { pgvEventReport } from '@/libs/tcss-report';
import {
  COUPONS_STATUS,
  COUPON_PRIZE_ID_MAP,
  LOTTERY_PRIZE_ID_MAP
} from '@/libs/constant';
import { getMyPrizes } from '@/libs/api';
import Toast from '@/components/toast';
import Panel from '@/components/panel.vue';
import { dateFormat } from '@/libs/utils';
export default {
  name: 'Home',
  components: { Panel, Toast },
  data() {
    return {
      dateFormat,
      COUPONS_STATUS,
      COUPON_PRIZE_ID_MAP,
      LOTTERY_PRIZE_ID_MAP,
      loading: false,
      hasError: false,
      errorTips: '',
      couponsInfo: [],
      qbCardsInfo: []
    };
  },
  mounted() {
    pgvEventReport('anniversary.activity.page.userPrize');
    this.getMyPrizes();
  },
  methods: {
    handleCopy(value) {
      const result = this.copyToClipboard(value);
      if (result) {
        this.errorTips = '已复制到粘贴板';
        this.hasError = true;
      } else {
        this.errorTips = '复制失败，请手动复制粘贴';
        this.hasError = true;
      }
    },
    async getMyPrizes() {
      try {
        this.loading = true;
        const result = await getMyPrizes();
        this.couponsInfo = result.couponsInfo;
        this.qbCardsInfo = result.qbCardsInfo;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.hasError = true;
      }
    },
    // 复制到粘贴板
    copyToClipboard(value) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', value);
      input.setAttribute('readonly', 'readonly'); // ios 键盘弹窗
      input.select();
      input.setSelectionRange(0, value.length); // 兼容ios
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        document.body.removeChild(input);
        return true; // 复制成功
      }
      document.body.removeChild(input);
      return false; // 复制失败
    }
  }
};
</script>
